import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../App.css";
import Dashheader from "../Dash-header/Dashheader";
import Sidebar from "../dashboard/Sidebar";
import "./submissions.css";

import SubCheck from "../../images/sub-checked.svg";
import SubCancel from "../../images/sub-cancel.svg";
import SubFolder from "../../images/sub-fold.svg";
import SubInfo from "../../images/add-info.svg";
import SubLock from "../../images/eoi-submitted.svg";
import SubNotify from "../../images/sub-notify.svg";
import SubCart from "../../images/shopping.svg";
import SubUpload from "../../images/sub-upload.svg";
import SubUser from "../../images/pers-details.svg";
import SubVerify from "../../images/prf-verified.svg";
import AccActive from "../../images/ac-actvd.svg";
import ProgressBar from "./progress.jsx";
import UserFooter from "../footer/UserFooter.jsx";

import { END_URL } from "../../config.js";

function Submissions() {
  const [expanded1, setExpanded] = useState(false);
  const [profile, setProfile] = useState(null);
  const [additionalInfo, setAdditionalInfo] = useState(null);
  const [submissionData, setSubmissionData] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = sessionStorage.getItem("authToken");
      if (!token) return;
      try {
        const res = await axios.get(`${END_URL}profiles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProfile(res.data);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchAdditionalInfo = async () => {
      const token = sessionStorage.getItem("authToken");
      if (!token) return;
      try {
        const res = await axios.get(`${END_URL}personaldetail`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdditionalInfo(res.data.personaldetail);
      } catch (error) {
        console.error("Failed to fetch additional info:", error);
      }
    };
    fetchAdditionalInfo();
  }, []);

  useEffect(() => {
    const fetchSubmission = async () => {
      const token = sessionStorage.getItem("authToken");
      if (!token) return;
      try {
        const res = await axios.get(`${END_URL}submission`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (
          res.data &&
          res.data.data &&
          res.data.data.submissions &&
          res.data.data.submissions.length > 0
        ) {
          setSubmissionData(res.data.data.submissions[0]);
        }
      } catch (error) {
        console.error("Error fetching submission:", error);
      }
    };
    fetchSubmission();
  }, []);

  function getPersonalDetailsCompletion(profile) {
    const personalDetailFields = [
      "name",
      "lastname",
      "email",
      "phone",
      "address",
      "city",
      "state",
      "postalcode",
      "country_id",
      "dob",
      "occupation",
    ];
    if (!profile) return 0;
    let filled = 0;
    personalDetailFields.forEach((field) => {
      const value = profile[field];
      if (value !== undefined && value !== null && value !== "") {
        filled++;
      }
    });
    return Math.round((filled / personalDetailFields.length) * 100);
  }

  function getAdditionalInfoCompletion(profile) {

      const additionalInfoFields = [
        "representing",
        "currentMember",
        "willingToRegister",
        "awareOfPricingProblems",
        // "feelTheDeceptive",
        "consent",
        "user_status"
      ];

      if (!profile) return 0;
      let filled = 0;
       let totalFields = additionalInfoFields.length;
   
       additionalInfoFields.forEach(field => {
         const value = profile[field];
         if (value !== undefined && value !== null && value !== '') {
           filled += 1;
         }
       });
   
       if (profile.representing === "Yes") {
         totalFields += 1;
         if (profile.dependents !== undefined && profile.dependents !== null && profile.dependents !== '') {
           filled += 1;
         }
       }
   
       return Math.round((filled / totalFields) * 100);
  }

  function getShoppingDetailsCompletion(profile) {
    const shoppingDetailFields = [
      "primary_shopper",
      "shopping_frequency",
      "average_spend",
      "sale_price_usage",
      "pricing_awareness",
      "supermarket_used",
      "household_people",
      "store_location",
      "preferred_contact",
      "heard_about",
      "consent",
    ];
    if (!profile) return 0;
    let filled = 0;
    shoppingDetailFields.forEach((field) => {
      const value = profile[field];
      if (Array.isArray(value)) {
        if (value.length > 0) filled++;
      } else if (value !== undefined && value !== null && value !== "") {
        filled++;
      }
    });
    return Math.round((filled / shoppingDetailFields.length) * 100);
  }

  const additionalInfoCompletion = additionalInfo
    ? getAdditionalInfoCompletion(additionalInfo)
    : 0;

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (progress < 100) {
      const timer = setInterval(() => {
        setProgress((prevProgress) => Math.min(prevProgress + 1, 100));
      }, 100);
      return () => clearInterval(timer);
    }
  }, [progress]);

  // if (!submissionData) {
  //   return <div>Loading...</div>;
  // }

  // Helper to choose message and badge based on completeness
  const sectionStatus = (completeMsg, incompleteMsg, isComplete) =>
    isComplete ? completeMsg : incompleteMsg;
    const isAdditionalInfoComplete =
    submissionData &&
    submissionData.AdditionalInfocomplete &&
    !submissionData.AdditionalInfocomplete.toLowerCase().includes(
      "please provide"
    );


  const stepsComplete = [
    profile?.user_status?.addition_status,                                      // AdditionalInfo
    profile?.profileverified,                         // Account verified
    profile && getShoppingDetailsCompletion(profile) === 100,                // ShoppingDetails
    profile && getPersonalDetailsCompletion(profile) === 100,                // PersonalDetails
    submissionData && submissionData.eoicomplete,                            // EOI
    submissionData && submissionData.FurtherInformationcomplete,             // FurtherInformation
  ];

  // Filter for truthy (i.e., completed) steps
  const completedSteps = stepsComplete.filter(Boolean).length;
  const totalSteps = stepsComplete.length;

  // Calculate percent complete
  const percentComplete = Math.round((completedSteps / totalSteps) * 100);


  console.log(submissionData, 'submissionDatasubmissionDatasubmissionData');


  return (
    <div className="dashboard-container full-width submission">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="form-container">
                <div className="dashbord-first"
                  dangerouslySetInnerHTML={{ __html: submissionData?.subcontent1 }}>
                </div>
                <div className="row sub-row1">
                  <div className="col-md-8 sub-col1">
                    <div className={`sub-card ${profile?.user_status?.addition_status ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={SubInfo} alt="Additional info icon" />
                      </span>
                      <h2>
                        {submissionData?.AdditionalInfo}{" "}
                        {profile?.user_status?.addition_status ? "Complete" : "Required"}
                      </h2>

                      {profile?.user_status?.addition_status ? (

                        <h5>Completed on date: {additionalInfo?.completed_formatted_date}</h5>
                      ) : (

                        <h5>Required by date: {submissionData?.AdditionalInfodate}</h5>
                      )}

                      <p>

                        {profile?.user_status?.addition_status

                          ? submissionData?.AdditionalInfocomplete

                          : submissionData?.AdditionalInfoincomplete}
                      </p>

                      {!profile?.user_status?.addition_status && (

                        <a href="/additionalinfo" className="subm-btn">
                          Complete Now
                        </a>
                      )}

                      <span
                        className={`status-badge ${profile?.user_status?.addition_status ? "complete" : ""
                          }`}
                      >
                        {profile?.user_status?.addition_status ? "Complete" : "Action Required"}
                      </span>
                    </div>



                    <div className={`sub-card${profile?.profileverified ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={SubVerify} alt="Account icon" />
                      </span>
                      <h2>{submissionData?.account} verified</h2>

                      {profile?.profileverified ? (

                          <h5>Completed on date: {profile?.profile_verified_formatted}</h5>
                        ) :

                      null}
                      
                      <p>
                        {sectionStatus(
                          submissionData?.accoutcomplete,
                          submissionData?.accountincomplete,
                          profile?.profileverified
                        )}
                      </p>
                      
                      <button
                        className="view-btn"
                        onClick={() => window.location.href = "/users"}
                      >
                        View Profile
                      </button>
                      <span
                        className={`status-badge ${profile?.profileverified ? "complete" : "Required"
                          }`}
                      >
                        {profile?.profileverified ? "Complete" : "Action Required"}
                      </span>
                    </div>


                    <div className={`sub-card${profile && getShoppingDetailsCompletion(profile) === 100 ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={SubCart} alt="Shopping details icon" />
                      </span>
                      <h2>
                        {submissionData?.ShoppingDetails}{" "}
                        {profile && getShoppingDetailsCompletion(profile) === 100
                          ? "Complete"
                          : "Required" /* replaced here */}
                      </h2>

                         {profile && getShoppingDetailsCompletion(profile) === 100 ? 
                          (
                             <h5>
                                Completed on date: {additionalInfo?.completed_formatted_date}
                              </h5>
                          ) :
                          ( 
                              <h5>
                                Required by date: {submissionData?.ShoppingDetailsdate}
                              </h5>
                            )
                          }
                       
                      <p>
                        {submissionData?.shoppingdetailscomplete &&
                          profile &&
                          getShoppingDetailsCompletion(profile) === 100
                          ? submissionData?.shoppingdetailscomplete
                          : submissionData?.shoppingdetailsincomplete}
                      </p>
                      <a href="/users/2" className="view-btn">
                        View/Edit Details
                      </a>

                      <span
                        className={`status-badge ${profile && getShoppingDetailsCompletion(profile) === 100
                            ? "complete"
                            : "" /* keep empty for required state */
                          }`}
                      >
                        {profile && getShoppingDetailsCompletion(profile) === 100
                          ? "Complete"
                          : "Action Required" /* replaced here */}
                      </span>
                    </div>


                    <div className={`sub-card${profile && getPersonalDetailsCompletion(profile) === 100 ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={SubUser} alt="Personal details icon" />
                      </span>
                      <h2>
                        {submissionData?.PersonalDetails}{" "}
                        {profile && getPersonalDetailsCompletion(profile) === 100
                          ? "Complete"
                          : "Required"}
                      </h2>
                      <h5>
                        Completed on date: {profile?.completed_formatted_date}
                      </h5>
                      <p>
                        {profile && getPersonalDetailsCompletion(profile) === 100
                          ? submissionData?.personaldetailscomplete
                          : submissionData?.personaldetailsincomplete}
                      </p>

                      <a href="/users" className="view-btn">
                        View/Edit Details
                      </a>

                      <span
                        className={`status-badge ${profile && getPersonalDetailsCompletion(profile) === 100 ? "complete" : ""
                          }`}
                      >
                        {profile && getPersonalDetailsCompletion(profile) === 100
                          ? "Complete"
                          : "Action Required"}
                      </span>
                    </div>



                    <div className={`sub-card${submissionData?.eoicomplete ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={AccActive} alt="Account activated icon" />
                      </span>
                      <h2>{submissionData?.eoi} Activated</h2>
                      <h5>
                        Completed on date:{" "}
                        {profile?.created_at
                          ? new Date(profile.created_at)
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, '-')
                          : "N/A"}

                      </h5>
                      <p>{submissionData?.eoicomplete}</p>
                      <span className="status-badge complete">Complete</span>
                    </div>



                    {/* {profile?.user_status?.notify_status && (
                    <div className="sub-card">
                      <span className="sub-img">
                        <img
                          src={SubNotify}
                          alt="Notifications and updates icon"
                        />
                      </span>
                      <h2>{submissionData.NotificationsUpdates} </h2>
                      <p>
                        {submissionData.NotificationsUpdatescomplete} 
                      </p>
                      <span className="status-badge complete">Complete</span>
                    </div>
                  )} */}

                    <div className={`sub-card${submissionData?.FurtherInformationcomplete ? ' activeclass' : ''}`}>
                      <span className="sub-img">
                        <img src={SubLock} alt="Account activated icon" />
                      </span>
                      <h2>{submissionData?.FurtherInformation} Submitted</h2>
                      <h5>
                        Completed on date:{" "}
                        
                        {profile?.created_at
                          ? new Date(profile.created_at)
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, '-')
                          : "N/A"}

                      </h5>
                      <p>{submissionData?.FurtherInformationcomplete}</p>
                      <span className="status-badge complete">Complete</span>
                    </div>

                    {/* 
                    <div className="sub-card">
                      <span className="sub-img">
                        <img src={SubCheck} alt="Expression of Interest icon" />
                      </span>
                      <h2>{submissionData.eoi}</h2>
                      <h5>Required by {submissionData.eoidate}</h5>
                      <p>{sectionStatus(submissionData.eoicomplete, submissionData.eoiincomplete, !!submissionData.eoicomplete)}</p>
                      <button className="subm-btn">Complete Now</button>
                      <span className="status-badge">{submissionData.eoicomplete ? 'Complete' : 'Action Required'}</span>
                    </div>

                   
                   

                  

                    <div className="sub-card">
                      <span className="sub-img"><img src={SubVerify} alt="Profile verified icon" /></span>
                      <h2>  {submissionData.Profile}  Status</h2>
                      <p>{sectionStatus(submissionData.Profilecomplete, submissionData.Profileincomplete, !!submissionData.Profilecomplete)}</p>
                    </div>


                    {profile?.user_status?.evidence && profile.user_status.evidence_status === 'Pending' && (
                      <div className="sub-card">
                        <span className="sub-img"><img src={SubUpload} alt="Evidence submitted icon" /></span>
                        <h2>Evidence Submitted</h2>
                        <p>Thanks! We’ve received your supporting documents. Our team will review them shortly.</p>
                      </div>
                    )}

                    {profile?.user_status?.evidence_status === 'Accepted' && (
                      <div className="sub-card">
                        <span className="sub-img"><img src={SubCheck} alt="Evidence Approved icon" /></span>
                        <h2>Evidence Approved</h2>
                        <p>Your documents have been verified.</p>
                      </div>
                    )}

                    {profile?.legalfiling && profile.legalfiling !== 0 && profile.legalfiling !== "0" && (
                      <div className="sub-card">
                        <span className="sub-img"><img src={SubFolder} alt="Legal Filing icon" /></span>
                        <h2>Preparation for Legal Filing</h2>
                        <p>Your details have been reviewed and are queued for inclusion in the legal filing.</p>
                      </div>
                    )}

                    {profile?.user_status?.evidence_status === 'Rejected' && (
                      <div className="sub-card">
                        <span className="sub-img"><img src={SubCancel} alt="Further info required icon" /></span>
                        <h2>Further Information Required</h2>
                        <p>We need some additional details from you. Please check your inbox or dashboard to complete your submission.</p>
                      </div>
                    )}

                    {profile?.legalaction && profile.legalaction !== 0 && (
                      <div className="sub-card">
                        <span className="sub-img"><img src={SubCart} alt="Awaiting legal action launch icon" /></span>
                        <h2>Awaiting Legal Action Launch</h2>
                        <p>We’re preparing the formal submission. You’ll receive an update once proceedings are filed.</p>
                      </div>
                    )} */}
                  </div>

                  <div className="col-md-4 sub-col2">
                    <div className="sub-card">
                      <div className="card-head">
                        <h4>Your Progress</h4>
                        <span className="prg-text">{percentComplete}% Complete</span>
                      </div>
                      <div className="prg-container" style={{ width: "100%" }}>
                        <ProgressBar progress={percentComplete} />
                      </div>
                      <h5>{completedSteps}/{totalSteps}</h5>
                      <p>Completed Steps</p>
                    </div>

                    <div className="sub-card"
                      dangerouslySetInnerHTML={{ __html: submissionData?.subcontent2 }}>
                    </div>
                  </div>
                </div>
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Submissions;
